// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"2b28b67e","453":"a8cd7e5f","468":"a1afd8c4","936":"5deadd8b"}[chunkId] + ".chunk.js";
};